module.exports = __webpack_public_path__ + "static/media/fabien-bazanegue.609883c6.jpg";